module.exports = __webpack_public_path__ + "img/lk-menu-key.74d730b5.svg";